// Agent commission methods and the shared per-shipment commission calculator.
// Rates live on the agent row; a shipment can override the METHOD (not the rate)
// via shipments.agComMethod.

export const AG_COM_METHODS = [
    { value: "bundle", label: "Bundle (₹/bundle)" },
    { value: "freight", label: "Freight (₹/ton)" },
    { value: "percentage", label: "Percentage (%)" },
    { value: "fullTruck", label: "Full Truck (flat ₹)" },
    { value: "bag", label: "Bag (₹/bag)" },
];

export function agComMethodLabel(method) {
    return AG_COM_METHODS.find((m) => m.value === method)?.label || method || "";
}

// method: the shipment override if set, else pass null/undefined to use the agent default.
export function calcAgentCommission({ method, agentData, quantity, weight, custFinalPrc }) {
    const m = method || agentData?.agComMethod || "percentage";
    const qty = Number(quantity) || 0;
    const wt = parseFloat(weight) || 0;
    const prc = Number(custFinalPrc) || 0;

    switch (m) {
        case "bundle": return (Number(agentData?.agComBundle) || 0) * qty;
        case "freight": return (Number(agentData?.agComFreight) || 0) * wt;
        case "fullTruck": return Number(agentData?.agComFullTruck) || 0;
        case "bag": return (Number(agentData?.agComBag) || 0) * qty;
        case "percentage":
        default: return prc * ((Number(agentData?.agComPer) || 0) / 100);
    }
}
